
var jq = jQuery;
var $ = jQuery;

var bpmod_current_requests = new Array()

jq(document).ready(function() {

    /** Flag/Unflag ***************************************************************/
    jq('a.bpm-report-link').click(function() {
        var link = jq(this);
        var inner = link.children('.bpm-inner-text');

        inner.addClass('ajax-loader');

        var href = link.attr('href');
        var data = href.replace(/[^?]*\?(.*)/, '$1&action=bpmodfrontend');

        if (bpmod_current_requests[data])
            return false;
        else
            bpmod_current_requests[data] = true;

        jq.post(ajaxurl, data,
            function(response) {

                link.fadeOut(100, function() {
                    switch (response.type) {
                        case 'success':
                        case 'fade warning':
                            link.toggleClass('bpm-unflagged');
                            link.toggleClass('bpm-flagged');

                            if (link.hasClass('bpm-unflagged'))
                                href = href.replace(/(.*)bpmod-action=[^&]*(.*)/, '$1bpmod-action=flag$2');
                            else if (link.hasClass('bpm-flagged'))
                                href = href.replace(/(.*)bpmod-action=[^&]*(.*)/, '$1bpmod-action=unflag$2');

                            href = href.replace(/(.*)_wpnonce=[^&]*(.*)/, '$1_wpnonce=' + response.new_nonce + '$2');

                            link.attr('href', href);

                            if (!link.hasClass('bpm-no-text'))
                                inner.html(response.msg);

                            if ('fade warning' == response.type) {
                                $was_no_text = link.hasClass('bpm-no-text');
                                window.setTimeout(function() {
                                    link.fadeOut(100, function() {
                                        if ($was_no_text) {
                                            inner.html('');
                                            link.addClass('bpm-no-text');
                                        } else
                                            inner.html(response.msg);
                                        link.fadeIn(100);
                                    });
                                }, 2500);
                                inner.html(response.fade_msg);
                            }
                            break;

                        case 'error':
                        default:
                            inner.html(response.msg);
                            link.removeClass('bpm-no-text');

                    }

                    inner.removeClass('ajax-loader');
                    jq(this).fadeIn(100);

                    bpmod_current_requests[data] = false;
                });

            }, 'json');

        return false;
    });

});

function bp_get_querystring( n ) {
    var half = location.search.split( n + '=' )[1];
    return half ? decodeURIComponent( half.split('&')[0] ) : null;
}







/*!
 * WordPress Social Login
 *
 * http://miled.github.io/wordpress-social-login/ | https://github.com/miled/wordpress-social-login
 *  (c) 2011-2014 Mohamed Mrassi and contributors | http://wordpress.org/plugins/wordpress-social-login/
 */

/**
 * Manage authentications via a popup
 *
 * Based on http://wordpress.org/extend/plugins/social-connect/
 */

/**
 * bind on click event to idps icons
 */
(function($){
    $(function(){
        $(document).on( 'click', 'a.wp-social-login-provider', function(){
            var popupurl = $( '#wsl_popup_base_url' ).val();

            var provider = $(this).attr("data-provider");

            var width  = 1000;
            var height = 600;
            var top    = ( screen.height / 2 ) - ( height / 2 ) - 50;
            var left   = ( screen.width  / 2 ) - ( width  / 2 );
            if(typeof popupurl !== "undefined"){
                window.open( popupurl + 'provider=' + provider, 'hybridauth_social_sing_on', 'location=1,status=0,scrollbars=0,height=' + height + ',width=' + width + ',top=' + top + ',left=' + left);
            }
        });
    });
})(jQuery);

/**
 * generate login wp form
 */
window.wsl_wordpress_social_login = function( config ){
    jQuery( '#loginform' ).unbind( 'submit.simplemodal-login' );

    var form_id = '#loginform';

    if( ! jQuery( '#loginform' ).length )
    {
        if( jQuery( '#registerform' ).length )
        {
            form_id = '#registerform';
        }

        else {
            var login_uri = jQuery( '#wsl_login_form_uri' ).val();

            jQuery('body').append( '<form id="loginform" method="post" action="' + login_uri + '"></form>' );

            jQuery('#loginform').append( '<input type="hidden" id="redirect_to" name="redirect_to" value="' + window.location.href + '">' );
        }
    }

    jQuery.each( config, function( key, value ){
        jQuery( '#' + key ).remove();

        jQuery( form_id ).append( '<input type="hidden" id="' + key + '" name="' + key + '" value="' + value + '">' );
    });

    if( jQuery( '#simplemodal-login-form' ).length )
    {
        var current_url = window.location.href;

        jQuery( '#redirect_to' ).remove();

        jQuery( form_id ).append( '<input type="hidden" id="redirect_to" name="redirect_to" value="' + current_url + '">' );
    }

    jQuery( form_id ).submit();
}

// AJAX Functions
var jq = jQuery;

// Global variable to prevent multiple AJAX requests
var bp_ajax_request = null;

// Global variables to temporarly store newest activities
var newest_activities = '';
var activity_last_recorded = 0;

jq(document).ready(function () {
    /**** Page Load Actions *******************************************************/

    /* Hide Forums Post Form */
    if ('-1' == window.location.search.indexOf('new') && jq('div.forums').length)
        jq('#new-topic-post').hide();
    else
        jq('#new-topic-post').show();

    /* Activity filter and scope set */
    bp_init_activity();

    /* Object filter and scope set. */
    var objects = ['members', 'groups', 'blogs', 'forums', 'group_members'];
    bp_init_objects(objects);

    /* @mention Compose Scrolling */
    var $whats_new = jq('#whats-new');
    if (jq.query.get('r') && $whats_new.length) {
        jq('#whats-new-options').animate({
            height: '140px'
        });
        jq("#whats-new-form textarea").animate({
            height: '150px'
        });
        jq.scrollTo($whats_new, 500, {
            offset: -125,
            easing: 'easeOutQuad'
        });
        var whats_new_content = $whats_new.val();
        $whats_new.val('').focus().val(whats_new_content);
    }

    /**** Activity Posting ********************************************************/

    /* Textarea focus */
    $whats_new.focus(function () {
        jq("#whats-new-options").animate({
            height: '60px'
        });
        jq("#whats-new-form textarea").animate({
            height: '150px'
        });
        jq("#aw-whats-new-submit").prop("disabled", false);

        var $whats_new_form = jq("form#whats-new-form");
        if ($whats_new_form.hasClass("submitted")) {
            $whats_new_form.removeClass("submitted");
        }

        // Return to the 'All Members' tab and 'Everything' filter,
        // to avoid inconsistencies with the heartbeat integration
        var $activity_all = jq('#activity-all');
        if ($activity_all.length) {
            if (!$activity_all.hasClass('selected')) {
                // reset to everyting
                jq('#activity-filter-select select').val('-1');
                $activity_all.children('a').trigger("click");
            } else if ('-1' != jq('#activity-filter-select select').val()) {
                jq('#activity-filter-select select').val('-1');
                jq('#activity-filter-select select').trigger('change');
            }
        }
    });

    /* On blur, shrink if it's empty */
    $whats_new.blur(function () {
        if (document.activeElement != this) {
            if (!this.value.match(/\S+/)) {
                this.value = "";
                jq("#whats-new-options").animate({
                    height: '60px'
                });
                jq("form#whats-new-form textarea").animate({
                    height: '120px'
                });
                jq("#aw-whats-new-submit").prop("disabled", true);
            }
        }
    });

    /* New posts */
    jq("#aw-whats-new-submit").on('click', function () {

        /*KT 20141001 - added quick way to add media into the post*/
        /*
         simply add a beforeclick handler to the object and modify the #whats-new texarea
         e.g.
         $("#aw-whats-new-submit").on("beforeclick", function(){
         //some important code
         });
         */
        try{
            jq(this).trigger("beforeclick");
        }
        catch(er){}

        var last_date_recorded = 0;
        var button = jq(this);
        var form = button.closest("form#whats-new-form");

        $('#status').hide();

        form.children().each(function () {
            if (jq.nodeName(this, "textarea") || jq.nodeName(this, "input"))
                jq(this).prop('disabled', true);
        });

        /* Remove any errors */
        jq('div.error').remove();
        button.addClass('loading');
        button.prop('disabled', true);
        form.addClass("submitted");



        /* Default POST values */
        var object = '';
        var item_id = jq("#whats-new-post-in").val();
        var content = jq("#whats-new").val();
        /*KT 20141001 allow hidden content to be prepended or appended to the published content*/
        if(jq("#whats-new").data("prepend_content"))
            content = jq("#whats-new").data("prepend_content") + content;
        if(jq("#whats-new").data("append_content"))
            content = content + jq("#whats-new").data("append_content");

        var firstrow = jq('#buddypress ul.activity-list li').first();
        var activity_row = firstrow;
        var timestamp = null;

        // Checks if at least one activity exists
        if (firstrow.length) {

            if (activity_row.hasClass('load-newest')) {
                activity_row = firstrow.next();
            }

            timestamp = activity_row.prop('class').match(/date-recorded-([0-9]+)/);
        }

        if (timestamp) {
            last_date_recorded = timestamp[1];
        }

        /* Set object for non-profile posts */
        if (item_id > 0) {
            object = jq("#whats-new-post-object").val();
        }

        jq.post(ajaxurl, {
                action: 'post_update',
                'cookie': bp_get_cookies(),
                '_wpnonce_post_update': jq("#_wpnonce_post_update").val(),
                'content': content,
                'object': object,
                'item_id': item_id,
                'since': last_date_recorded,
                '_bp_as_nonce': jq('#_bp_as_nonce').val() || ''
            },
            function (response) {

                form.children().each(function () {
                    if (jq.nodeName(this, "textarea") || jq.nodeName(this, "input")) {
                        jq(this).prop('disabled', false);
                    }
                });

                /* Check for errors and append if found. */
                if (response[0] + response[1] == '-1') {
                    form.prepend(response.substr(2, response.length));
                    jq('#' + form.attr('id') + ' div.error').hide().fadeIn(200);
                } else {
                    if (0 == jq("ul.activity-list").length) {
                        jq("div.error").slideUp(100).remove();
                        jq("#message").slideUp(100).remove();
                        jq("div.activity").append('<ul id="activity-stream" class="activity-list item-list">');
                    }

                    if (firstrow.hasClass('load-newest'))
                        firstrow.remove();

                    jq("#activity-stream").prepend(response);

                    if (!last_date_recorded)
                        jq("#activity-stream li:first").addClass('new-update just-posted');

                    //KT 20141001 - update the most recent post to use the current date

                    var d = new Date();
                    var month = new Array();
                    month[0] = "Jan";
                    month[1] = "Feb";
                    month[2] = "Mar";
                    month[3] = "Apr";
                    month[4] = "May";
                    month[5] = "Jun";
                    month[6] = "Jul";
                    month[7] = "Aug";
                    month[8] = "Sep";
                    month[9] = "Oct";
                    month[10] = "Nov";
                    month[11] = "Dec";
                    var lmonth = month[d.getMonth()];
                    var lday = d.getDate();

                    jq("#activity-stream li.new-update .timeline-badge").html('<div class="day">' + lday + '</div><div class="month">' + lmonth + '</div>');

                    if (0 != jq("#latest-update").length) {

                        var l = jq("#activity-stream li.new-update .activity-content .activity-inner p").html();
                        var v = jq("#activity-stream li.new-update .activity-content .activity-header p a.view").attr('href');

                        var ltext = jq("#activity-stream li.new-update .activity-content .activity-inner p").text();

                        var u = '';
                        if (ltext != '')
                            u = l + ' ';

                        u += '<a href="' + v + '" rel="nofollow">' + BP_DTheme.view + '</a>';

                        jq("#latest-update").slideUp(300, function () {
                            jq("#latest-update").html(u);
                            jq("#latest-update").slideDown(300);
                        });
                    }

                    jq("li.new-update").hide().slideDown(300);
                    jq("li.new-update").removeClass('new-update');
                    jq("#whats-new").val('');

                    // reset vars to get newest activities
                    newest_activities = '';
                    activity_last_recorded = 0;
                }

                jq("#whats-new-options").animate({
                    height: '0px'
                });
                jq("#whats-new-form textarea").animate({
                    height: '120px'
                });
                jq("#aw-whats-new-submit").prop("disabled", true).removeClass('loading');
            });

        return false;
    });

    /* List tabs event delegation */
    jq('div.activity-type-tabs').on('click', function (event) {
        var target = jq(event.target).parent();

        if (event.target.nodeName == 'STRONG' || event.target.nodeName == 'SPAN')
            target = target.parent();
        else if (event.target.nodeName != 'A')
            return false;

        /* Reset the page */
        jq.cookie('bp-activity-oldestpage', 1, {
            path: '/'
        });

        /* Activity Stream Tabs */
        var scope = target.attr('id').substr(9, target.attr('id').length);
        var filter = jq("#activity-filter-select select").val();

        if (scope == 'mentions')
            jq('#' + target.attr('id') + ' a strong').remove();

        bp_activity_request(scope, filter);

        return false;
    });

    /* Activity filter select */
    jq('#activity-filter-select select').change(function () {
        var selected_tab = jq('div.activity-type-tabs li.selected');

        if (!selected_tab.length)
            var scope = null;
        else
            var scope = selected_tab.attr('id').substr(9, selected_tab.attr('id').length);

        var filter = jq(this).val();

        bp_activity_request(scope, filter);

        return false;
    });

    /* Stream event delegation */
    jq('div.activity').on('click', function (event) {
        var target = jq(event.target);

        /* Favoriting activity stream items */
        if (target.hasClass('fav') || target.hasClass('unfav')) {
            var type = target.hasClass('fav') ? 'fav' : 'unfav';
            var parent = target.closest('.activity-item');
            var parent_id = parent.attr('id').substr(9, parent.attr('id').length);

            target.addClass('loading');

            jq.post(ajaxurl, {
                    action: 'activity_mark_' + type,
                    'cookie': bp_get_cookies(),
                    'id': parent_id
                },
                function (response) {
                    target.removeClass('loading');

                    target.fadeOut(200, function () {
                        jq(this).html(response);
                        jq(this).attr('title', 'fav' == type ? BP_DTheme.remove_fav : BP_DTheme.mark_as_fav);
                        jq(this).fadeIn(200);
                    });

                    if ('fav' == type) {
                        if (!jq('.item-list-tabs #activity-favs-personal-li').length) {
                            if (!jq('.item-list-tabs #activity-favorites').length)
                                jq('.item-list-tabs ul #activity-mentions').before('<li id="activity-favorites"><a href="#">' + BP_DTheme.my_favs + ' <span>0</span></a></li>');

                            jq('.item-list-tabs ul #activity-favorites span').html(Number(jq('.item-list-tabs ul #activity-favorites span').html()) + 1);
                        }

                        target.removeClass('fav');
                        target.addClass('unfav');

                    } else {
                        target.removeClass('unfav');
                        target.addClass('fav');

                        jq('.item-list-tabs ul #activity-favorites span').html(Number(jq('.item-list-tabs ul #activity-favorites span').html()) - 1);

                        if (!Number(jq('.item-list-tabs ul #activity-favorites span').html())) {
                            if (jq('.item-list-tabs ul #activity-favorites').hasClass('selected'))
                                bp_activity_request(null, null);

                            jq('.item-list-tabs ul #activity-favorites').remove();
                        }
                    }

                    if ('activity-favorites' == jq('.item-list-tabs li.selected').attr('id'))
                        target.closest('.activity-item').slideUp(100);
                });

            return false;
        }

        /* Delete activity stream items */
        if (target.hasClass('delete-activity')) {
            var li = target.parents('div.activity ul li');
            var id = li.attr('id').substr(9, li.attr('id').length);
            var link_href = target.attr('href');
            var nonce = link_href.split('_wpnonce=');
            var timestamp = li.prop('class').match(/date-recorded-([0-9]+)/);

            nonce = nonce[1];

            target.addClass('loading');

            jq.post(ajaxurl, {
                    action: 'delete_activity',
                    'cookie': bp_get_cookies(),
                    'id': id,
                    '_wpnonce': nonce
                },
                function (response) {

                    if (response[0] + response[1] == '-1') {
                        li.prepend(response.substr(2, response.length));
                        li.children('#message').hide().fadeIn(300);
                    } else {
                        li.slideUp(300);

                        // reset vars to get newest activities
                        if (timestamp && activity_last_recorded == timestamp[1]) {
                            newest_activities = '';
                            activity_last_recorded = 0;
                        }
                    }
                });

            return false;
        }

        // Spam activity stream items
        if (target.hasClass('spam-activity')) {
            var li = target.parents('div.activity ul li');
            var timestamp = li.prop('class').match(/date-recorded-([0-9]+)/);
            target.addClass('loading');

            jq.post(ajaxurl, {
                    action: 'bp_spam_activity',
                    'cookie': encodeURIComponent(document.cookie),
                    'id': li.attr('id').substr(9, li.attr('id').length),
                    '_wpnonce': target.attr('href').split('_wpnonce=')[1]
                },

                function (response) {
                    if (response[0] + response[1] === '-1') {
                        li.prepend(response.substr(2, response.length));
                        li.children('#message').hide().fadeIn(300);
                    } else {
                        li.slideUp(300);
                        // reset vars to get newest activities
                        if (timestamp && activity_last_recorded == timestamp[1]) {
                            newest_activities = '';
                            activity_last_recorded = 0;
                        }
                    }
                });

            return false;
        }

        /* Load more updates at the end of the page */
        if (target.parent().hasClass('load-more')) {
            jq("#buddypress li.load-more").addClass('loading');

            if (null == jq.cookie('bp-activity-oldestpage'))
                jq.cookie('bp-activity-oldestpage', 1, {
                    path: '/'
                });

            var oldest_page = (jq.cookie('bp-activity-oldestpage') * 1) + 1;

            var just_posted = [];

            jq('.activity-list li.just-posted').each(function () {
                just_posted.push(jq(this).attr('id').replace('activity-', ''));
            });

            jq.post(ajaxurl, {
                    action: 'activity_get_older_updates',
                    'cookie': bp_get_cookies(),
                    'page': oldest_page,
                    'exclude_just_posted': just_posted.join(',')
                },
                function (response) {
                    jq("#buddypress li.load-more").removeClass('loading');
                    jq.cookie('bp-activity-oldestpage', oldest_page, {
                        path: '/'
                    });
                    jq("#buddypress ul.activity-list").append(response.contents);

                    target.parent().hide();
                }, 'json');

            return false;
        }

        /* Load newest updates at the top of the list */
        if (target.parent().hasClass('load-newest')) {

            event.preventDefault();

            target.parent().hide();

            /**
             * If a plugin is updating the recorded_date of an activity
             * it will be loaded as a new one. We need to look in the
             * stream and eventually remove similar ids to avoid "double".
             */
            activity_html = jq.parseHTML(newest_activities);

            jq.each(activity_html, function (i, el) {
                if ('LI' == el.nodeName && jq(el).hasClass('just-posted')) {
                    if (jq('#' + jq(el).attr('id')).length)
                        jq('#' + jq(el).attr('id')).remove();
                }
            });

            // Now the stream is cleaned, prepend newest
            jq('#buddypress ul.activity-list').prepend(newest_activities);

            // reset the newest activities now they're displayed
            newest_activities = '';
        }
    });

    // Activity "Read More" links
    jq('div.activity').on('click', '.activity-read-more a', function (event) {
        var target = jq(event.target);
        var link_id = target.parent().attr('id').split('-');
        var a_id = link_id[3];
        var type = link_id[0]; /* activity or acomment */

        var inner_class = type == 'acomment' ? 'acomment-content' : 'activity-inner';
        var a_inner = jq('#' + type + '-' + a_id + ' .' + inner_class + ':first');
        jq(target).addClass('loading');

        jq.post(ajaxurl, {
                action: 'get_single_activity_content',
                'activity_id': a_id
            },
            function (response) {
                jq(a_inner).slideUp(300).html(response).slideDown(300);
            });

        return false;
    });

    /**** Activity Comments *******************************************************/

    /* Hide all activity comment forms */
    jq('form.ac-form').hide();

    /* Hide excess comments */
    if (jq('.activity-comments').length)
        bp_legacy_theme_hide_comments();

    /* Activity list event delegation */
    jq('div.activity').on('click', function (event) {
        var target = jq(event.target);

        /* Comment / comment reply links */
        if (target.hasClass('acomment-reply') || target.parent().hasClass('acomment-reply')) {
            if (target.parent().hasClass('acomment-reply'))
                target = target.parent();

            var id = target.attr('id');
            ids = id.split('-');

            var a_id = ids[2]
            var c_id = target.attr('href').substr(10, target.attr('href').length);
            var form = jq('#ac-form-' + a_id);

            form.css('display', 'none');
            form.removeClass('root');
            jq('.ac-form').hide();

            /* Hide any error messages */
            form.children('div').each(function () {
                if (jq(this).hasClass('error'))
                    jq(this).hide();
            });

            if (ids[1] != 'comment') {
                jq('#acomment-' + c_id).append(form);
            } else {
                jq('#activity-' + a_id + ' .activity-comments').append(form);
            }

            if (form.parent().hasClass('activity-comments'))
                form.addClass('root');

            form.slideDown(200);
            jq.scrollTo(form, 500, {
                offset: -100,
                easing: 'easeOutQuad'
            });
            jq('#ac-form-' + ids[2] + ' textarea').focus();

            return false;
        }

        /* Activity comment posting */
        if (target.attr('name') == 'ac_form_submit') {
            var form = target.parents('form');
            var form_parent = form.parent();
            var form_id = form.attr('id').split('-');

            if (!form_parent.hasClass('activity-comments')) {
                var tmp_id = form_parent.attr('id').split('-');
                var comment_id = tmp_id[1];
            } else {
                var comment_id = form_id[2];
            }

            var content = jq('#' + form.attr('id') + ' textarea');

            /* Hide any error messages */
            jq('#' + form.attr('id') + ' div.error').hide();
            target.addClass('loading').prop('disabled', true);
            content.addClass('loading').prop('disabled', true);

            var ajaxdata = {
                action: 'new_activity_comment',
                'cookie': bp_get_cookies(),
                '_wpnonce_new_activity_comment': jq("#_wpnonce_new_activity_comment").val(),
                'comment_id': comment_id,
                'form_id': form_id[2],
                'content': content.val()
            };

            // Akismet
            var ak_nonce = jq('#_bp_as_nonce_' + comment_id).val();
            if (ak_nonce) {
                ajaxdata['_bp_as_nonce_' + comment_id] = ak_nonce;
            }

            jq.post(ajaxurl, ajaxdata, function (response) {
                target.removeClass('loading');
                content.removeClass('loading');

                /* Check for errors and append if found. */
                if (response[0] + response[1] == '-1') {
                    form.append(jq(response.substr(2, response.length)).hide().fadeIn(200));
                } else {
                    var activity_comments = form.parent();
                    form.fadeOut(200, function () {
                        if (0 == activity_comments.children('ul').length) {
                            if (activity_comments.hasClass('activity-comments')) {
                                activity_comments.prepend('<ul></ul>');
                            } else {
                                activity_comments.append('<ul></ul>');
                            }
                        }

                        /* Preceeding whitespace breaks output with jQuery 1.9.0 */
                        var the_comment = jq.trim(response);

                        activity_comments.children('ul').append(jq(the_comment).hide().fadeIn(200));
                        form.children('textarea').val('');
                        activity_comments.parent().addClass('has-comments');
                    });
                    jq('#' + form.attr('id') + ' textarea').val('');

                    /* Increase the "Reply (X)" button count */
                    jq('#activity-' + form_id[2] + ' a.acomment-reply span').html(Number(jq('#activity-' + form_id[2] + ' a.acomment-reply span').html()) + 1);

                    // Increment the 'Show all x comments' string, if present
                    var show_all_a = activity_comments.find('.show-all').find('a');
                    if (show_all_a) {
                        var new_count = jq('li#activity-' + form_id[2] + ' a.acomment-reply span').html();
                        show_all_a.html(BP_DTheme.show_x_comments.replace('%d', new_count));
                    }
                }

                jq(target).prop("disabled", false);
                jq(content).prop("disabled", false);
            });

            return false;
        }

        /* Deleting an activity comment */
        if (target.hasClass('acomment-delete')) {
            var link_href = target.attr('href');
            var comment_li = target.parent().parent();
            var form = comment_li.parents('div.activity-comments').children('form');

            var nonce = link_href.split('_wpnonce=');
            nonce = nonce[1];

            var comment_id = link_href.split('cid=');
            comment_id = comment_id[1].split('&');
            comment_id = comment_id[0];

            target.addClass('loading');

            /* Remove any error messages */
            jq('.activity-comments ul .error').remove();

            /* Reset the form position */
            comment_li.parents('.activity-comments').append(form);

            jq.post(ajaxurl, {
                    action: 'delete_activity_comment',
                    'cookie': bp_get_cookies(),
                    '_wpnonce': nonce,
                    'id': comment_id
                },
                function (response) {
                    /* Check for errors and append if found. */
                    if (response[0] + response[1] == '-1') {
                        comment_li.prepend(jq(response.substr(2, response.length)).hide().fadeIn(200));
                    } else {
                        var children = jq('#' + comment_li.attr('id') + ' ul').children('li');
                        var child_count = 0;
                        jq(children).each(function () {
                            if (!jq(this).is(':hidden'))
                                child_count++;
                        });
                        comment_li.fadeOut(200, function () {
                            comment_li.remove();
                        });

                        /* Decrease the "Reply (X)" button count */
                        var count_span = jq('#' + comment_li.parents('#activity-stream > li').attr('id') + ' a.acomment-reply span');
                        var new_count = count_span.html() - (1 + child_count);
                        count_span.html(new_count);

                        // Change the 'Show all x comments' text
                        var show_all_a = comment_li.siblings('.show-all').find('a');
                        if (show_all_a) {
                            show_all_a.html(BP_DTheme.show_x_comments.replace('%d', new_count));
                        }

                        /* If that was the last comment for the item, remove the has-comments class to clean up the styling */
                        if (0 == new_count) {
                            jq(comment_li.parents('#activity-stream > li')).removeClass('has-comments');
                        }
                    }
                });

            return false;
        }

        // Spam an activity stream comment
        if (target.hasClass('spam-activity-comment')) {
            var link_href = target.attr('href');
            var comment_li = target.parent().parent();

            target.addClass('loading');

            // Remove any error messages
            jq('.activity-comments ul div.error').remove();

            // Reset the form position
            comment_li.parents('.activity-comments').append(comment_li.parents('.activity-comments').children('form'));

            jq.post(ajaxurl, {
                    action: 'bp_spam_activity_comment',
                    'cookie': encodeURIComponent(document.cookie),
                    '_wpnonce': link_href.split('_wpnonce=')[1],
                    'id': link_href.split('cid=')[1].split('&')[0]
                },

                function (response) {
                    // Check for errors and append if found.
                    if (response[0] + response[1] == '-1') {
                        comment_li.prepend(jq(response.substr(2, response.length)).hide().fadeIn(200));

                    } else {
                        var children = jq('#' + comment_li.attr('id') + ' ul').children('li');
                        var child_count = 0;
                        jq(children).each(function () {
                            if (!jq(this).is(':hidden')) {
                                child_count++;
                            }
                        });
                        comment_li.fadeOut(200);

                        // Decrease the "Reply (X)" button count
                        var parent_li = comment_li.parents('#activity-stream > li');
                        jq('#' + parent_li.attr('id') + ' a.acomment-reply span').html(jq('#' + parent_li.attr('id') + ' a.acomment-reply span').html() - (1 + child_count));
                    }
                });

            return false;
        }

        /* Showing hidden comments - pause for half a second */
        if (target.parent().hasClass('show-all')) {
            target.parent().addClass('loading');

            setTimeout(function () {
                target.parent().parent().children('li').fadeIn(200, function () {
                    target.parent().remove();
                });
            }, 600);

            return false;
        }

        // Canceling an activity comment
        if (target.hasClass('ac-reply-cancel')) {
            jq(target).closest('.ac-form').slideUp(200);
            return false;
        };
    });

    /* Escape Key Press for cancelling comment forms */
    jq(document).keydown(function (e) {
        e = e || window.event;
        if (e.target)
            element = e.target;
        else if (e.srcElement)
            element = e.srcElement;

        if (element.nodeType == 3)
            element = element.parentNode;

        if (e.ctrlKey == true || e.altKey == true || e.metaKey == true)
            return;

        var keyCode = (e.keyCode) ? e.keyCode : e.which;

        if (keyCode == 27) {
            if (element.tagName == 'TEXTAREA') {
                if (jq(element).hasClass('ac-input'))
                    jq(element).parent().parent().parent().slideUp(200);
            }
        }
    });

    /**** Directory Search ****************************************************/

    /* The search form on all directory pages */
    jq('.dir-search, .groups-members-search').on('click', function (event) {
        if (jq(this).hasClass('no-ajax'))
            return;

        var target = jq(event.target);

        if (target.attr('type') == 'submit') {
            var css_id = jq('.item-list-tabs li.selected').attr('id').split('-');
            var object = css_id[0];
            var template = null;

            // The Group Members page specifies its own template
            if ('members' == object && 'groups' == css_id[1]) {
                object = 'group_members';
                template = 'groups/single/members';
            }

            bp_filter_request(object, jq.cookie('bp-' + object + '-filter'), jq.cookie('bp-' + object + '-scope'), 'div.' + object, target.parent().children('label').children('input').val(), 1, jq.cookie('bp-' + object + '-extras'), null, template);

            return false;
        }
    });

    /**** Tabs and Filters ****************************************************/

    /* When a navigation tab is clicked - e.g. | All Groups | My Groups | */
    jq('div.item-list-tabs').on('click', function (event) {
        if (jq(this).hasClass('no-ajax'))
            return;



        var targetElem = (event.target.nodeName == 'SPAN') ? event.target.parentNode : event.target;
        var target = jq(targetElem).parent();
        if ('LI' == target[0].nodeName && !target.hasClass('last')) {
            var css_id = target.attr('id').split('-');
            var object = css_id[0];

            if ('activity' == object)
                return false;

            var scope = css_id[1];
            var filter = jq("#" + object + "-order-select select").val();
            var search_terms = jq("#" + object + "_search").val();

            bp_filter_request(object, filter, scope, 'div.' + object, search_terms, 1, jq.cookie('bp-' + object + '-extras'));

            return false;
        }
    });

    /* When the filter select box is changed re-query */
    jq('li.filter select').change(function () {
        if (jq('.item-list-tabs li.selected').length)
            var el = jq('.item-list-tabs li.selected');
        else
            var el = jq(this);

        var css_id = el.attr('id').split('-');
        var object = css_id[0];
        var scope = css_id[1];
        var filter = jq(this).val();
        var search_terms = false;
        var template = null;

        if (jq('.dir-search input').length)
            search_terms = jq('.dir-search input').val();

        // The Group Members page has a different selector for its
        // search terms box
        var $gm_search = jq('.groups-members-search input');
        if ($gm_search.length) {
            search_terms = $gm_search.val();
        }

        // On the Groups Members page, we specify a template
        if ('members' == object && 'groups' == scope) {
            object = 'group_members';
            template = 'groups/single/members';
        }

        if ('friends' == object)
            object = 'members';

        bp_filter_request(object, filter, scope, 'div.' + object, search_terms, 1, jq.cookie('bp-' + object + '-extras'), null, template);

        return false;
    });

    /* All pagination links run through this function */
    jq('#buddypress').on('click', function (event) {
        var target = jq(event.target);

        if (target.hasClass('button'))
            return true;

        if (target.parent().parent().hasClass('pagination') && !target.parent().parent().hasClass('no-ajax')) {
            if (target.hasClass('dots') || target.hasClass('current'))
                return false;

            if (jq('.item-list-tabs li.selected').length)
                var el = jq('.item-list-tabs li.selected');
            else
                var el = jq('li.filter select');

            var css_id = el.attr('id').split('-');
            var object = css_id[0];
            var search_terms = false;
            var pagination_id = jq(target).closest('.pagination-links').attr('id');
            var template = null;
            var page_number = 1;

            //var page_number = target.attr('href').split('=');
            //page_number = page_number[1];
            if ( jq(target).hasClass('next') )
                page_number = Number( jq('.pagination span.current').html() ) + 1;
            else if ( jq(target).hasClass('prev') )
                page_number = Number( jq('.pagination span.current').html() ) - 1;
            else
                page_number = Number( jq(target).html() );

            // Search terms
            if (jq('div.dir-search input').length)
                search_terms = jq('.dir-search input').val();

            // The Group Members page has a different selector for
            // its search terms box
            var $gm_search = jq('.groups-members-search input');
            if ($gm_search.length) {
                search_terms = $gm_search.val();
            }

            // On the Groups Members page, we specify a template
            if ('members' == object && 'groups' == css_id[1]) {
                object = 'group_members';
                template = 'groups/single/members';
            }

            // On the Admin > Requests page, we need to reset the object,
            // since "admin" isn't specific enough
            if ('admin' == object && jq('body').hasClass('membership-requests')) {
                object = 'requests';
            }

            if (pagination_id.indexOf('pag-bottom') !== -1) {
                var caller = 'pag-bottom';
            } else {
                var caller = null;
            }

            bp_filter_request(object, jq.cookie('bp-' + object + '-filter'), jq.cookie('bp-' + object + '-scope'), 'div.' + object, search_terms, page_number, jq.cookie('bp-' + object + '-extras'), caller, template);

            return false;
        }

    });

    /**** New Forum Directory Post **************************************/

    /* Hit the "New Topic" button on the forums directory page */
    jq('a.show-hide-new').on('click', function () {
        if (!jq('#new-topic-post').length)
            return false;

        if (jq('#new-topic-post').is(":visible"))
            jq('#new-topic-post').slideUp(200);
        else
            jq('#new-topic-post').slideDown(200, function () {
                jq('#topic_title').focus();
            });

        return false;
    });

    /* Cancel the posting of a new forum topic */
    jq('#submit_topic_cancel').on('click', function () {
        if (!jq('#new-topic-post').length)
            return false;

        jq('#new-topic-post').slideUp(200);
        return false;
    });

    /* Clicking a forum tag */
    jq('#forum-directory-tags a').on('click', function () {
        bp_filter_request('forums', 'tags', jq.cookie('bp-forums-scope'), 'div.forums', jq(this).html().replace(/&nbsp;/g, '-'), 1, jq.cookie('bp-forums-extras'));
        return false;
    });

    /** Invite Friends Interface ****************************************/

    /* Select a user from the list of friends and add them to the invite list */
    jq("#send-invite-form").on('click', '#invite-list input', function () {
        // invites-loop template contains a div with the .invite class
        // We use the existence of this div to check for old- vs new-
        // style templates.
        var invites_new_template = jq("#send-invite-form > .invite").length;

        jq('.ajax-loader').toggle();

        // Dim the form until the response arrives
        if (invites_new_template) {
            jq(this).parents('ul').find('input').prop('disabled', true);
        }

        var friend_id = jq(this).val();

        if (jq(this).prop('checked') == true) {
            var friend_action = 'invite';
        } else {
            var friend_action = 'uninvite';
        }

        if (!invites_new_template) {
            jq('.item-list-tabs li.selected').addClass('loading');
        }

        jq.post(ajaxurl, {
                action: 'groups_invite_user',
                'friend_action': friend_action,
                'cookie': bp_get_cookies(),
                '_wpnonce': jq("#_wpnonce_invite_uninvite_user").val(),
                'friend_id': friend_id,
                'group_id': jq("#group_id").val()
            },
            function (response) {
                if (jq("#message")) {
                    jq("#message").hide();
                }

                if (invites_new_template) {
                    // With new-style templates, we refresh the
                    // entire list
                    bp_filter_request('invite', 'bp-invite-filter', 'bp-invite-scope', 'div.invite', false, 1, '', '', '');
                } else {
                    // Old-style templates manipulate only the
                    // single invitation element
                    jq('.ajax-loader').toggle();

                    if (friend_action == 'invite') {
                        jq('#friend-list').append(response);
                    } else if (friend_action == 'uninvite') {
                        jq('#friend-list li#uid-' + friend_id).remove();
                    }

                    jq('.item-list-tabs li.selected').removeClass('loading');
                }
            });
    });

    /* Remove a user from the list of users to invite to a group */
    jq("#send-invite-form").on('click', 'a.remove', function () {
        // invites-loop template contains a div with the .invite class
        // We use the existence of this div to check for old- vs new-
        // style templates.
        var invites_new_template = jq("#send-invite-form > .invite").length;

        jq('.ajax-loader').toggle();

        var friend_id = jq(this).attr('id');
        friend_id = friend_id.split('-');
        friend_id = friend_id[1];

        jq.post(ajaxurl, {
                action: 'groups_invite_user',
                'friend_action': 'uninvite',
                'cookie': bp_get_cookies(),
                '_wpnonce': jq("#_wpnonce_invite_uninvite_user").val(),
                'friend_id': friend_id,
                'group_id': jq("#group_id").val()
            },
            function (response) {
                if (invites_new_template) {
                    // With new-style templates, we refresh the
                    // entire list
                    bp_filter_request('invite', 'bp-invite-filter', 'bp-invite-scope', 'div.invite', false, 1, '', '', '');
                } else {
                    // Old-style templates manipulate only the
                    // single invitation element
                    jq('.ajax-loader').toggle();
                    jq('#friend-list #uid-' + friend_id).remove();
                    jq('#invite-list #f-' + friend_id).prop('checked', false);
                }
            });

        return false;
    });

    /** Profile Visibility Settings *********************************/
    jq('.visibility-toggle-link').on('click', function (event) {
        event.preventDefault();

        jq(this).parent().hide()
            .siblings('.field-visibility-settings').show();
    });

    jq('.field-visibility-settings-close').on('click', function (event) {
        event.preventDefault();

        var settings_div = jq(this).parent(),
            vis_setting_text = settings_div.find('input:checked').parent().text();

        settings_div.hide()
            .siblings('.field-visibility-settings-toggle')
            .children('.current-visibility-level').text(vis_setting_text).end()
            .show();
    });

    jq("#profile-edit-form input:not(:submit), #profile-edit-form textarea, #profile-edit-form select, #signup_form input:not(:submit), #signup_form textarea, #signup_form select").change(function () {
        var shouldconfirm = true;

        jq('#profile-edit-form input:submit, #signup_form input:submit').on('click', function () {
            shouldconfirm = false;
        });

        window.onbeforeunload = function (e) {
            if (shouldconfirm) {
                return BP_DTheme.unsaved_changes;
            }
        };
    });

    /** Friendship Requests **************************************/

    /* Accept and Reject friendship request buttons */
    jq("#friend-list a.accept, #friend-list a.reject").on('click', function () {
        var button = jq(this);
        var li = jq(this).parents('#friend-list li');
        var action_div = jq(this).parents('li div.action');

        var id = li.attr('id').substr(11, li.attr('id').length);
        var link_href = button.attr('href');

        var nonce = link_href.split('_wpnonce=');
        nonce = nonce[1];

        if (jq(this).hasClass('accepted') || jq(this).hasClass('rejected'))
            return false;

        if (jq(this).hasClass('accept')) {
            var action = 'accept_friendship';
            action_div.children('a.reject').css('visibility', 'hidden');
        } else {
            var action = 'reject_friendship';
            action_div.children('a.accept').css('visibility', 'hidden');
        }

        button.addClass('loading');

        jq.post(ajaxurl, {
                action: action,
                'cookie': bp_get_cookies(),
                'id': id,
                '_wpnonce': nonce
            },
            function (response) {
                button.removeClass('loading');

                if (response[0] + response[1] == '-1') {
                    li.prepend(response.substr(2, response.length));
                    li.children('#message').hide().fadeIn(200);
                } else {
                    button.fadeOut(100, function () {
                        if (jq(this).hasClass('accept')) {
                            action_div.children('a.reject').hide();
                            jq(this).html(BP_DTheme.accepted).contents().unwrap();
                        } else {
                            action_div.children('a.accept').hide();
                            jq(this).html(BP_DTheme.rejected).contents().unwrap();
                        }
                    });
                }
            });

        return false;
    });

    /* Add / Remove friendship buttons */
    jq('#members-dir-list, #members-group-list').on('click', '.friendship-button a', function () {
        jq(this).parent().addClass('loading');
        var fid = jq(this).attr('id');
        fid = fid.split('-');
        fid = fid[1];

        var nonce = jq(this).attr('href');
        nonce = nonce.split('?_wpnonce=');
        nonce = nonce[1].split('&');
        nonce = nonce[0];

        var thelink = jq(this);

        jq.post(ajaxurl, {
                action: 'addremove_friend',
                'cookie': bp_get_cookies(),
                'fid': fid,
                '_wpnonce': nonce
            },
            function (response) {
                var action = thelink.attr('rel');
                var parentdiv = thelink.parent();

                if (action == 'add') {
                    jq(parentdiv).fadeOut(200,
                        function () {
                            parentdiv.removeClass('add_friend');
                            parentdiv.removeClass('loading');
                            parentdiv.addClass('pending_friend');
                            parentdiv.fadeIn(200).html(response);
                        }
                    );

                } else if (action == 'remove') {
                    jq(parentdiv).fadeOut(200,
                        function () {
                            parentdiv.removeClass('remove_friend');
                            parentdiv.removeClass('loading');
                            parentdiv.addClass('add');
                            parentdiv.fadeIn(200).html(response);
                        }
                    );
                }
            });
        return false;
    });

    /** Group Join / Leave Buttons **************************************/

    // Confirmation when clicking Leave Group in group headers
    jq('#buddypress').on('click', '.group-button .leave-group', function () {
        if (false == confirm(BP_DTheme.leave_group_confirm)) {
            return false;
        }
    });

    jq('#groups-dir-list').on('click', '.group-button a', function () {
        var gid = jq(this).parent().attr('id');
        gid = gid.split('-');
        gid = gid[1];

        var nonce = jq(this).attr('href');
        nonce = nonce.split('?_wpnonce=');
        nonce = nonce[1].split('&');
        nonce = nonce[0];

        var thelink = jq(this);

        // Leave Group confirmation within directories - must intercept
        // AJAX request
        if (thelink.hasClass('leave-group') && false == confirm(BP_DTheme.leave_group_confirm)) {
            return false;
        }

        jq.post(ajaxurl, {
                action: 'joinleave_group',
                'cookie': bp_get_cookies(),
                'gid': gid,
                '_wpnonce': nonce
            },
            function (response) {
                var parentdiv = thelink.parent();

                // user groups page
                if (!jq('body.directory').length) {
                    location.href = location.href;

                    // groups directory
                } else {
                    jq(parentdiv).fadeOut(200,
                        function () {
                            parentdiv.fadeIn(200).html(response);

                            var mygroups = jq('#groups-personal span');
                            var add = 1;

                            if (thelink.hasClass('leave-group')) {
                                // hidden groups slide up
                                if (parentdiv.hasClass('hidden')) {
                                    parentdiv.closest('li').slideUp(200);
                                }

                                add = 0;
                            } else if (thelink.hasClass('request-membership')) {
                                add = false;
                            }

                            // change the "My Groups" value
                            if (mygroups.length && add !== false) {
                                if (add) {
                                    mygroups.text((mygroups.text() >> 0) + 1);
                                } else {
                                    mygroups.text((mygroups.text() >> 0) - 1);
                                }
                            }

                        }
                    );
                }
            });
        return false;
    });

    /** Button disabling ************************************************/

    jq('#buddypress').on('click', '.pending', function () {
        return false;
    });

    /** Private Messaging ******************************************/

    /** Message search*/
    jq('.message-search').on('click', function (event) {
        if (jq(this).hasClass('no-ajax'))
            return;

        var target = jq(event.target);

        if (target.attr('type') == 'submit') {
            //var css_id = jq('.item-list-tabs li.selected').attr('id').split( '-' );
            var object = 'messages';

            bp_filter_request(object, jq.cookie('bp-' + object + '-filter'), jq.cookie('bp-' + object + '-scope'), 'div.' + object, target.parent().children('label').children('input').val(), 1, jq.cookie('bp-' + object + '-extras'));

            return false;
        }
    });

    /* AJAX send reply functionality */
    jq("#send_reply_button").click(
        function () {
            var order = jq('#messages_order').val() || 'ASC',
                offset = jq('#message-recipients').offset();

            var button = jq("#send_reply_button");
            jq(button).addClass('loading');

            jq.post(ajaxurl, {
                    action: 'messages_send_reply',
                    'cookie': bp_get_cookies(),
                    '_wpnonce': jq("#send_message_nonce").val(),

                    'content': jq("#message_content").val(),
                    'send_to': jq("#send_to").val(),
                    'subject': jq("#subject").val(),
                    'thread_id': jq("#thread_id").val()
                },
                function (response) {
                    if (response[0] + response[1] == "-1") {
                        jq('#send-reply').prepend(response.substr(2, response.length));
                    } else {
                        jq('#send-reply #message').remove();
                        jq("#message_content").val('');

                        if ('ASC' == order) {
                            jq('#send-reply').before(response);
                        } else {
                            jq('#message-recipients').after(response);
                            jq(window).scrollTop(offset.top);
                        }

                        jq(".new-message").hide().slideDown(200, function () {
                            jq('.new-message').removeClass('new-message');
                        });
                    }
                    jq(button).removeClass('loading');
                });

            return false;
        }
    );

    /* Marking private messages as read and unread */
    jq("#mark_as_read, #mark_as_unread").click(function () {
        var checkboxes_tosend = '';
        var checkboxes = jq("#message-threads tr td input[type='checkbox']");

        if ('mark_as_unread' == jq(this).attr('id')) {
            var currentClass = 'read'
            var newClass = 'unread'
            var unreadCount = 1;
            var inboxCount = 0;
            var unreadCountDisplay = 'inline';
            var action = 'messages_markunread';
        } else {
            var currentClass = 'unread'
            var newClass = 'read'
            var unreadCount = 0;
            var inboxCount = 1;
            var unreadCountDisplay = 'none';
            var action = 'messages_markread';
        }

        checkboxes.each(function (i) {
            if (jq(this).is(':checked')) {
                if (jq('#m-' + jq(this).attr('value')).hasClass(currentClass)) {
                    checkboxes_tosend += jq(this).attr('value');
                    jq('#m-' + jq(this).attr('value')).removeClass(currentClass);
                    jq('#m-' + jq(this).attr('value')).addClass(newClass);
                    var thread_count = jq('#m-' + jq(this).attr('value') + ' td span.unread-count').html();

                    jq('#m-' + jq(this).attr('value') + ' td span.unread-count').html(unreadCount);
                    jq('#m-' + jq(this).attr('value') + ' td span.unread-count').css('display', unreadCountDisplay);

                    var inboxcount = jq('tr.unread').length;

                    jq('#user-messages span').html(inboxcount);

                    if (i != checkboxes.length - 1) {
                        checkboxes_tosend += ','
                    }
                }
            }
        });
        jq.post(ajaxurl, {
            action: action,
            'thread_ids': checkboxes_tosend
        });
        return false;
    });

    /* Selecting unread and read messages in inbox */
    jq('body.messages #item-body div.messages').on('change', '#message-type-select', function () {
        var selection = this.value;
        var checkboxes = jq("td input[type='checkbox']");

        checkboxes.each(function (i) {
            checkboxes[i].checked = "";
        });

        var checked_value = "checked";
        switch (selection) {
            case 'unread':
                checkboxes = jq("tr.unread td input[type='checkbox']");
                break;
            case 'read':
                checkboxes = jq("tr.read td input[type='checkbox']");
                break;
            case '':
                checked_value = "";
                break;
        }

        checkboxes.each(function (i) {
            checkboxes[i].checked = checked_value;
        });
    });

    /* Bulk delete messages */
    jq('body.messages #item-body div.messages').on('click', '.messages-options-nav a', function () {
        if (-1 == jq.inArray(this.id, Array('delete_sentbox_messages', 'delete_inbox_messages'))) {
            return;
        }

        checkboxes_tosend = '';
        checkboxes = jq("#message-threads tr td input[type='checkbox']");

        jq('#message').remove();
        jq(this).addClass('loading');

        jq(checkboxes).each(function (i) {
            if (jq(this).is(':checked'))
                checkboxes_tosend += jq(this).attr('value') + ',';
        });

        if ('' == checkboxes_tosend) {
            jq(this).removeClass('loading');
            return false;
        }

        jq.post(ajaxurl, {
            action: 'messages_delete',
            'thread_ids': checkboxes_tosend
        }, function (response) {
            if (response[0] + response[1] == "-1") {
                jq('#message-threads').prepend(response.substr(2, response.length));
            } else {
                jq('#message-threads').before('<div id="message" class="updated"><p>' + response + '</p></div>');

                jq(checkboxes).each(function (i) {
                    if (jq(this).is(':checked')) {
                        // We need to uncheck because message is only hidden
                        // Otherwise, AJAX will be fired again with same data
                        jq(this).attr('checked', false);
                        jq(this).parent().parent().fadeOut(150);
                    }
                });
            }

            jq('#message').hide().slideDown(150);
            jq("#delete_inbox_messages, #delete_sentbox_messages").removeClass('loading');
        });

        return false;
    });

    /* Close site wide notices in the sidebar */
    jq("#close-notice").on('click', function () {
        jq(this).addClass('loading');
        jq('#sidebar div.error').remove();

        jq.post(ajaxurl, {
                action: 'messages_close_notice',
                'notice_id': jq('.notice').attr('rel').substr(2, jq('.notice').attr('rel').length)
            },
            function (response) {
                jq("#close-notice").removeClass('loading');

                if (response[0] + response[1] == '-1') {
                    jq('.notice').prepend(response.substr(2, response.length));
                    jq('#sidebar div.error').hide().fadeIn(200);
                } else {
                    jq('.notice').slideUp(100);
                }
            });
        return false;
    });

    /* Toolbar & wp_list_pages Javascript IE6 hover class */
    jq("#wp-admin-bar ul.main-nav li, #nav li").mouseover(function () {
        jq(this).addClass('sfhover');
    });

    jq("#wp-admin-bar ul.main-nav li, #nav li").mouseout(function () {
        jq(this).removeClass('sfhover');
    });

    /* Clear BP cookies on logout */
    jq('a.logout').on('click', function () {
        jq.cookie('bp-activity-scope', null, {
            path: '/'
        });
        jq.cookie('bp-activity-filter', null, {
            path: '/'
        });
        jq.cookie('bp-activity-oldestpage', null, {
            path: '/'
        });

        var objects = ['members', 'groups', 'blogs', 'forums'];
        jq(objects).each(function (i) {
            jq.cookie('bp-' + objects[i] + '-scope', null, {
                path: '/'
            });
            jq.cookie('bp-' + objects[i] + '-filter', null, {
                path: '/'
            });
            jq.cookie('bp-' + objects[i] + '-extras', null, {
                path: '/'
            });
        });
    });

    /* if js is enabled then replace the no-js class by a js one */
    if (jq('body').hasClass('no-js'))
        jq('body').attr('class', jq('body').attr('class').replace(/no-js/, 'js'));

    /** Activity HeartBeat ************************************************/

    // Set the interval and the namespace event
    if (typeof wp != 'undefined' && typeof wp.heartbeat != 'undefined' && typeof BP_DTheme.pulse != 'undefined') {

        wp.heartbeat.interval(Number(BP_DTheme.pulse));

        jq.fn.extend({
            'heartbeat-send': function () {
                return this.bind('heartbeat-send.buddypress');
            }
        });

    }

    // Set the last id to request after
    jq(document).on('heartbeat-send.buddypress', function (e, data) {

        firstrow = 0;

        // First row is default latest activity id
        if (jq('#buddypress ul.activity-list li').first().prop('id')) {
            // getting the timestamp
            timestamp = jq('#buddypress ul.activity-list li').first().prop('class').match(/date-recorded-([0-9]+)/);

            if (timestamp) {
                firstrow = timestamp[1];
            }
        }

        if (0 == activity_last_recorded || Number(firstrow) > activity_last_recorded)
            activity_last_recorded = Number(firstrow);

        data['bp_activity_last_recorded'] = activity_last_recorded;
    });

    // Increment newest_activities and activity_last_recorded if data has been returned
    jq(document).on('heartbeat-tick', function (e, data) {

        // Only proceed if we have newest activities
        if (!data['bp_activity_newest_activities']) {
            return;
        }

        newest_activities = data['bp_activity_newest_activities']['activities'] + newest_activities;
        activity_last_recorded = Number(data['bp_activity_newest_activities']['last_recorded']);

        if (jq('#buddypress ul.activity-list li').first().hasClass('load-newest'))
            return;

        jq('#buddypress ul.activity-list').prepend('<li class="load-newest"><a href="#newest">' + BP_DTheme.newest + '</a></li>');
    });
});

/* Setup activity scope and filter based on the current cookie settings. */
function bp_init_activity() {
    /* Reset the page */
    jq.cookie('bp-activity-oldestpage', 1, {
        path: '/'
    });

    if (null != jq.cookie('bp-activity-filter') && jq('#activity-filter-select').length)
        jq('#activity-filter-select select option[value="' + jq.cookie('bp-activity-filter') + '"]').prop('selected', true);

    /* Activity Tab Set */
    if (null != jq.cookie('bp-activity-scope') && jq('.activity-type-tabs').length) {
        jq('.activity-type-tabs li').each(function () {
            jq(this).removeClass('selected');
        });
        jq('#activity-' + jq.cookie('bp-activity-scope') + ', .item-list-tabs li.current').addClass('selected');
    }
}

/* Setup object scope and filter based on the current cookie settings for the object. */
function bp_init_objects(objects) {
    jq(objects).each(function (i) {
        if (null != jq.cookie('bp-' + objects[i] + '-filter') && jq('#' + objects[i] + '-order-select select').length)
            jq('#' + objects[i] + '-order-select select option[value="' + jq.cookie('bp-' + objects[i] + '-filter') + '"]').prop('selected', true);

        if (null != jq.cookie('bp-' + objects[i] + '-scope') && jq('div.' + objects[i]).length) {
            jq('.item-list-tabs li').each(function () {
                jq(this).removeClass('selected');
            });
            jq('#' + objects[i] + '-' + jq.cookie('bp-' + objects[i] + '-scope') + ', #object-nav li.current').addClass('selected');
        }
    });
}

/* Filter the current content list (groups/members/blogs/topics) */
function bp_filter_request(object, filter, scope, target, search_terms, page, extras, caller, template) {
    if ('activity' == object)
        return false;

    if (jq.query.get('s') && !search_terms)
        search_terms = jq.query.get('s');

    if (null == scope)
        scope = 'all';

    /* Save the settings we want to remain persistent to a cookie */
    jq.cookie('bp-' + object + '-scope', scope, {
        path: '/'
    });
    jq.cookie('bp-' + object + '-filter', filter, {
        path: '/'
    });
    jq.cookie('bp-' + object + '-extras', extras, {
        path: '/'
    });

    /* Set the correct selected nav and filter */
    jq('.item-list-tabs li').each(function () {
        jq(this).removeClass('selected');
    });
    jq('#' + object + '-' + scope + ', #object-nav li.current').addClass('selected');
    jq('.item-list-tabs li.selected').addClass('loading');
    jq('.item-list-tabs select option[value="' + filter + '"]').prop('selected', true);

    if ('friends' == object || 'group_members' == object) {
        object = 'members';
    }

    if (bp_ajax_request)
        bp_ajax_request.abort();

    // fade out the content immediately and show loading...
    jq(target).fadeOut(100, function () {
        jq(this).html("Loading ...");
        jq(this).fadeIn(100);
    });
    bp_ajax_request = jq.post(ajaxurl, {
            action: object + '_filter',
            'cookie': bp_get_cookies(),
            'object': object,
            'filter': filter,
            'search_terms': search_terms,
            'scope': scope,
            'page': page,
            'extras': extras,
            'template': template
        },
        function (response) {
            /* animate to top if called from bottom pagination */
            if (caller == 'pag-bottom' && jq('#subnav').length) {
                var top = jq('#subnav').parent();
                jq('html,body').animate({
                    scrollTop: top.offset().top
                }, 'slow', function () {
                    jq(target).fadeOut(100, function () {
                        jq(this).html(response);
                        jq(this).fadeIn(100);
                    });
                });

            } else {
                jq(target).fadeOut(100, function () {
                    jq(this).html(response);
                    jq(this).fadeIn(100);
                });
            }

            jq('.item-list-tabs li.selected').removeClass('loading');
        });
}

/* Activity Loop Requesting */
function bp_activity_request(scope, filter) {
    /* Save the type and filter to a session cookie */
    jq.cookie('bp-activity-scope', scope, {
        path: '/'
    });
    jq.cookie('bp-activity-filter', filter, {
        path: '/'
    });
    jq.cookie('bp-activity-oldestpage', 1, {
        path: '/'
    });

    /* Remove selected and loading classes from tabs */
    jq('.item-list-tabs li').each(function () {
        jq(this).removeClass('selected loading');
    });
    /* Set the correct selected nav and filter */
    jq('#activity-' + scope + ', .item-list-tabs li.current').addClass('selected');
    jq('#object-nav.item-list-tabs li.selected, div.activity-type-tabs li.selected').addClass('loading');
    jq('#activity-filter-select select option[value="' + filter + '"]').prop('selected', true);

    /* Reload the activity stream based on the selection */
    jq('.widget_bp_activity_widget h2 span.ajax-loader').show();

    if (bp_ajax_request)
        bp_ajax_request.abort();

    bp_ajax_request = jq.post(ajaxurl, {
            action: 'activity_widget_filter',
            'cookie': bp_get_cookies(),
            '_wpnonce_activity_filter': jq("#_wpnonce_activity_filter").val(),
            'scope': scope,
            'filter': filter
        },
        function (response) {
            jq('.widget_bp_activity_widget h2 span.ajax-loader').hide();

            jq('div.activity').fadeOut(100, function () {
                jq(this).html(response.contents);
                jq(this).fadeIn(100);

                /* Selectively hide comments */
                bp_legacy_theme_hide_comments();
            });

            /* Update the feed link */
            if (null != response.feed_url)
                jq('.directory #subnav li.feed a, .home-page #subnav li.feed a').attr('href', response.feed_url);

            jq('.item-list-tabs li.selected').removeClass('loading');

        }, 'json');
}

/* Hide long lists of activity comments, only show the latest five root comments. */
function bp_legacy_theme_hide_comments() {
    var comments_divs = jq('div.activity-comments');

    if (!comments_divs.length)
        return false;

    comments_divs.each(function () {
        if (jq(this).children('ul').children('li').length < 5) return;

        var comments_div = jq(this);
        var parent_li = comments_div.parents('#activity-stream > li');
        var comment_lis = jq(this).children('ul').children('li');
        var comment_count = ' ';

        if (jq('#' + parent_li.attr('id') + ' a.acomment-reply span').length)
            var comment_count = jq('#' + parent_li.attr('id') + ' a.acomment-reply span').html();

        comment_lis.each(function (i) {
            /* Show the latest 5 root comments */
            if (i < comment_lis.length - 5) {
                jq(this).addClass('hidden');
                jq(this).toggle();

                if (!i)
                    jq(this).before('<li class="show-all"><a href="#' + parent_li.attr('id') + '/show-all/" title="' + BP_DTheme.show_all_comments + '">' + BP_DTheme.show_x_comments.replace('%d', comment_count) + '</a></li>');
            }
        });

    });
}

/* Helper Functions */

function checkAll() {
    var checkboxes = document.getElementsByTagName("input");
    for (var i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].type == "checkbox") {
            if ($("check_all").checked == "") {
                checkboxes[i].checked = "";
            } else {
                checkboxes[i].checked = "checked";
            }
        }
    }
}

/**
 * Deselects any select options or input options for the specified field element.
 *
 * @param {String} container HTML ID of the field
 * @since BuddyPress (1.2.0)
 */
function clear(container) {
    container = document.getElementById(container);
    if (!container) {
        return;
    }

    var radioButtons = container.getElementsByTagName('INPUT'),
        options = container.getElementsByTagName('OPTION'),
        i = 0;

    if (radioButtons) {
        for (i = 0; i < radioButtons.length; i++) {
            radioButtons[i].checked = '';
        }
    }

    if (options) {
        for (i = 0; i < options.length; i++) {
            options[i].selected = false;
        }
    }
}

/* Returns a querystring of BP cookies (cookies beginning with 'bp-') */
function bp_get_cookies() {
    // get all cookies and split into an array
    var allCookies = document.cookie.split(";");

    var bpCookies = {};
    var cookiePrefix = 'bp-';

    // loop through cookies
    for (var i = 0; i < allCookies.length; i++) {
        var cookie = allCookies[i];
        var delimiter = cookie.indexOf("=");
        var name = jq.trim(unescape(cookie.slice(0, delimiter)));
        var value = unescape(cookie.slice(delimiter + 1));

        // if BP cookie, store it
        if (name.indexOf(cookiePrefix) == 0) {
            bpCookies[name] = value;
        }
    }

    // returns BP cookies as querystring
    return encodeURIComponent(jq.param(bpCookies));
}

/* ScrollTo plugin - just inline and minified */
;
(function ($) {
    var h = $.scrollTo = function (a, b, c) {
        $(window).scrollTo(a, b, c)
    };
    h.defaults = {
        axis: 'xy',
        duration: parseFloat($.fn.jquery) >= 1.3 ? 0 : 1,
        limit: true
    };
    h.window = function (a) {
        return $(window)._scrollable()
    };
    $.fn._scrollable = function () {
        return this.map(function () {
            var a = this,
                isWin = !a.nodeName || $.inArray(a.nodeName.toLowerCase(), ['iframe', '#document', 'html', 'body']) != -1;
            if (!isWin) return a;
            var b = (a.contentWindow || a).document || a.ownerDocument || a;
            return /webkit/i.test(navigator.userAgent) || b.compatMode == 'BackCompat' ? b.body : b.documentElement
        })
    };
    $.fn.scrollTo = function (e, f, g) {
        if (typeof f == 'object') {
            g = f;
            f = 0
        }
        if (typeof g == 'function') g = {
            onAfter: g
        };
        if (e == 'max') e = 9e9;
        g = $.extend({}, h.defaults, g);
        f = f || g.duration;
        g.queue = g.queue && g.axis.length > 1;
        if (g.queue) f /= 2;
        g.offset = both(g.offset);
        g.over = both(g.over);
        return this._scrollable().each(function () {
            if (e == null) return;
            var d = this,
                $elem = $(d),
                targ = e,
                toff, attr = {},
                win = $elem.is('html,body');
            switch (typeof targ) {
                case 'number':
                case 'string':
                    if (/^([+-]=?)?\d+(\.\d+)?(px|%)?$/.test(targ)) {
                        targ = both(targ);
                        break
                    }
                    targ = $(targ, this);
                    if (!targ.length) return;
                case 'object':
                    if (targ.is || targ.style) toff = (targ = $(targ)).offset()
            }
            $.each(g.axis.split(''), function (i, a) {
                var b = a == 'x' ? 'Left' : 'Top',
                    pos = b.toLowerCase(),
                    key = 'scroll' + b,
                    old = d[key],
                    max = h.max(d, a);
                if (toff) {
                    attr[key] = toff[pos] + (win ? 0 : old - $elem.offset()[pos]);
                    if (g.margin) {
                        attr[key] -= parseInt(targ.css('margin' + b)) || 0;
                        attr[key] -= parseInt(targ.css('border' + b + 'Width')) || 0
                    }
                    attr[key] += g.offset[pos] || 0;
                    if (g.over[pos]) attr[key] += targ[a == 'x' ? 'width' : 'height']() * g.over[pos]
                } else {
                    var c = targ[pos];
                    attr[key] = c.slice && c.slice(-1) == '%' ? parseFloat(c) / 100 * max : c
                } if (g.limit && /^\d+$/.test(attr[key])) attr[key] = attr[key] <= 0 ? 0 : Math.min(attr[key], max);
                if (!i && g.queue) {
                    if (old != attr[key]) animate(g.onAfterFirst);
                    delete attr[key]
                }
            });
            animate(g.onAfter);

            function animate(a) {
                $elem.animate(attr, f, g.easing, a && function () {
                        a.call(this, e, g)
                    })
            }
        }).end()
    };
    h.max = function (a, b) {
        var c = b == 'x' ? 'Width' : 'Height',
            scroll = 'scroll' + c;
        if (!$(a).is('html,body')) return a[scroll] - $(a)[c.toLowerCase()]();
        var d = 'client' + c,
            html = a.ownerDocument.documentElement,
            body = a.ownerDocument.body;
        return Math.max(html[scroll], body[scroll]) - Math.min(html[d], body[d])
    };

    function both(a) {
        return typeof a == 'object' ? a : {
            top: a,
            left: a
        }
    }
})(jQuery);

/* jQuery Easing Plugin, v1.3 - //gsgd.co.uk/sandbox/jquery/easing/ */
jQuery.easing.jswing = jQuery.easing.swing;
jQuery.extend(jQuery.easing, {
    def: "easeOutQuad",
    swing: function (e, f, a, h, g) {
        return jQuery.easing[jQuery.easing.def](e, f, a, h, g)
    },
    easeInQuad: function (e, f, a, h, g) {
        return h * (f /= g) * f + a
    },
    easeOutQuad: function (e, f, a, h, g) {
        return -h * (f /= g) * (f - 2) + a
    },
    easeInOutQuad: function (e, f, a, h, g) {
        if ((f /= g / 2) < 1) {
            return h / 2 * f * f + a
        }
        return -h / 2 * ((--f) * (f - 2) - 1) + a
    },
    easeInCubic: function (e, f, a, h, g) {
        return h * (f /= g) * f * f + a
    },
    easeOutCubic: function (e, f, a, h, g) {
        return h * ((f = f / g - 1) * f * f + 1) + a
    },
    easeInOutCubic: function (e, f, a, h, g) {
        if ((f /= g / 2) < 1) {
            return h / 2 * f * f * f + a
        }
        return h / 2 * ((f -= 2) * f * f + 2) + a
    },
    easeInQuart: function (e, f, a, h, g) {
        return h * (f /= g) * f * f * f + a
    },
    easeOutQuart: function (e, f, a, h, g) {
        return -h * ((f = f / g - 1) * f * f * f - 1) + a
    },
    easeInOutQuart: function (e, f, a, h, g) {
        if ((f /= g / 2) < 1) {
            return h / 2 * f * f * f * f + a
        }
        return -h / 2 * ((f -= 2) * f * f * f - 2) + a
    },
    easeInQuint: function (e, f, a, h, g) {
        return h * (f /= g) * f * f * f * f + a
    },
    easeOutQuint: function (e, f, a, h, g) {
        return h * ((f = f / g - 1) * f * f * f * f + 1) + a
    },
    easeInOutQuint: function (e, f, a, h, g) {
        if ((f /= g / 2) < 1) {
            return h / 2 * f * f * f * f * f + a
        }
        return h / 2 * ((f -= 2) * f * f * f * f + 2) + a
    },
    easeInSine: function (e, f, a, h, g) {
        return -h * Math.cos(f / g * (Math.PI / 2)) + h + a
    },
    easeOutSine: function (e, f, a, h, g) {
        return h * Math.sin(f / g * (Math.PI / 2)) + a
    },
    easeInOutSine: function (e, f, a, h, g) {
        return -h / 2 * (Math.cos(Math.PI * f / g) - 1) + a
    },
    easeInExpo: function (e, f, a, h, g) {
        return (f == 0) ? a : h * Math.pow(2, 10 * (f / g - 1)) + a
    },
    easeOutExpo: function (e, f, a, h, g) {
        return (f == g) ? a + h : h * (-Math.pow(2, -10 * f / g) + 1) + a
    },
    easeInOutExpo: function (e, f, a, h, g) {
        if (f == 0) {
            return a
        }
        if (f == g) {
            return a + h
        }
        if ((f /= g / 2) < 1) {
            return h / 2 * Math.pow(2, 10 * (f - 1)) + a
        }
        return h / 2 * (-Math.pow(2, -10 * --f) + 2) + a
    },
    easeInCirc: function (e, f, a, h, g) {
        return -h * (Math.sqrt(1 - (f /= g) * f) - 1) + a
    },
    easeOutCirc: function (e, f, a, h, g) {
        return h * Math.sqrt(1 - (f = f / g - 1) * f) + a
    },
    easeInOutCirc: function (e, f, a, h, g) {
        if ((f /= g / 2) < 1) {
            return -h / 2 * (Math.sqrt(1 - f * f) - 1) + a
        }
        return h / 2 * (Math.sqrt(1 - (f -= 2) * f) + 1) + a
    },
    easeInElastic: function (f, h, e, l, k) {
        var i = 1.70158;
        var j = 0;
        var g = l;
        if (h == 0) {
            return e
        }
        if ((h /= k) == 1) {
            return e + l
        }
        if (!j) {
            j = k * 0.3
        }
        if (g < Math.abs(l)) {
            g = l;
            var i = j / 4
        } else {
            var i = j / (2 * Math.PI) * Math.asin(l / g)
        }
        return -(g * Math.pow(2, 10 * (h -= 1)) * Math.sin((h * k - i) * (2 * Math.PI) / j)) + e
    },
    easeOutElastic: function (f, h, e, l, k) {
        var i = 1.70158;
        var j = 0;
        var g = l;
        if (h == 0) {
            return e
        }
        if ((h /= k) == 1) {
            return e + l
        }
        if (!j) {
            j = k * 0.3
        }
        if (g < Math.abs(l)) {
            g = l;
            var i = j / 4
        } else {
            var i = j / (2 * Math.PI) * Math.asin(l / g)
        }
        return g * Math.pow(2, -10 * h) * Math.sin((h * k - i) * (2 * Math.PI) / j) + l + e
    },
    easeInOutElastic: function (f, h, e, l, k) {
        var i = 1.70158;
        var j = 0;
        var g = l;
        if (h == 0) {
            return e
        }
        if ((h /= k / 2) == 2) {
            return e + l
        }
        if (!j) {
            j = k * (0.3 * 1.5)
        }
        if (g < Math.abs(l)) {
            g = l;
            var i = j / 4
        } else {
            var i = j / (2 * Math.PI) * Math.asin(l / g)
        } if (h < 1) {
            return -0.5 * (g * Math.pow(2, 10 * (h -= 1)) * Math.sin((h * k - i) * (2 * Math.PI) / j)) + e
        }
        return g * Math.pow(2, -10 * (h -= 1)) * Math.sin((h * k - i) * (2 * Math.PI) / j) * 0.5 + l + e
    },
    easeInBack: function (e, f, a, i, h, g) {
        if (g == undefined) {
            g = 1.70158
        }
        return i * (f /= h) * f * ((g + 1) * f - g) + a
    },
    easeOutBack: function (e, f, a, i, h, g) {
        if (g == undefined) {
            g = 1.70158
        }
        return i * ((f = f / h - 1) * f * ((g + 1) * f + g) + 1) + a
    },
    easeInOutBack: function (e, f, a, i, h, g) {
        if (g == undefined) {
            g = 1.70158
        }
        if ((f /= h / 2) < 1) {
            return i / 2 * (f * f * (((g *= (1.525)) + 1) * f - g)) + a
        }
        return i / 2 * ((f -= 2) * f * (((g *= (1.525)) + 1) * f + g) + 2) + a
    },
    easeInBounce: function (e, f, a, h, g) {
        return h - jQuery.easing.easeOutBounce(e, g - f, 0, h, g) + a
    },
    easeOutBounce: function (e, f, a, h, g) {
        if ((f /= g) < (1 / 2.75)) {
            return h * (7.5625 * f * f) + a
        } else {
            if (f < (2 / 2.75)) {
                return h * (7.5625 * (f -= (1.5 / 2.75)) * f + 0.75) + a
            } else {
                if (f < (2.5 / 2.75)) {
                    return h * (7.5625 * (f -= (2.25 / 2.75)) * f + 0.9375) + a
                } else {
                    return h * (7.5625 * (f -= (2.625 / 2.75)) * f + 0.984375) + a
                }
            }
        }
    },
    easeInOutBounce: function (e, f, a, h, g) {
        if (f < g / 2) {
            return jQuery.easing.easeInBounce(e, f * 2, 0, h, g) * 0.5 + a
        }
        return jQuery.easing.easeOutBounce(e, f * 2 - g, 0, h, g) * 0.5 + h * 0.5 + a
    }
});

/* jQuery Cookie plugin */
jQuery.cookie = function (name, value, options) {
    if (typeof value != 'undefined') {
        options = options || {};
        if (value === null) {
            value = '';
            options.expires = -1;
        }
        var expires = '';
        if (options.expires && (typeof options.expires == 'number' || options.expires.toUTCString)) {
            var date;
            if (typeof options.expires == 'number') {
                date = new Date();
                date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000));
            } else {
                date = options.expires;
            }
            expires = '; expires=' + date.toUTCString();
        }
        var path = options.path ? '; path=' + (options.path) : '';
        var domain = options.domain ? '; domain=' + (options.domain) : '';
        var secure = options.secure ? '; secure' : '';
        document.cookie = [name, '=', encodeURIComponent(value), expires, path, domain, secure].join('');
    } else {
        var cookieValue = null;
        if (document.cookie && document.cookie != '') {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = jQuery.trim(cookies[i]);
                if (cookie.substring(0, name.length + 1) == (name + '=')) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }
};

/* jQuery querystring plugin */
new function (settings) {
    var $separator = settings.separator || '&';
    var $spaces = settings.spaces === false ? false : true;
    var $suffix = settings.suffix === false ? '' : '[]';
    var $prefix = settings.prefix === false ? false : true;
    var $hash = $prefix ? settings.hash === true ? "#" : "?" : "";
    var $numbers = settings.numbers === false ? false : true;
    jQuery.query = new function () {
        var is = function (o, t) {
            return o != undefined && o !== null && (!!t ? o.constructor == t : true)
        };
        var parse = function (path) {
            var m, rx = /\[([^[]*)\]/g,
                match = /^([^[]+)(\[.*\])?$/.exec(path),
                base = match[1],
                tokens = [];
            while (m = rx.exec(match[2])) tokens.push(m[1]);
            return [base, tokens]
        };
        var set = function (target, tokens, value) {
            var o, token = tokens.shift();
            if (typeof target != 'object') target = null;
            if (token === "") {
                if (!target) target = [];
                if (is(target, Array)) {
                    target.push(tokens.length == 0 ? value : set(null, tokens.slice(0), value))
                } else if (is(target, Object)) {
                    var i = 0;
                    while (target[i++] != null);
                    target[--i] = tokens.length == 0 ? value : set(target[i], tokens.slice(0), value)
                } else {
                    target = [];
                    target.push(tokens.length == 0 ? value : set(null, tokens.slice(0), value))
                }
            } else if (token && token.match(/^\s*[0-9]+\s*$/)) {
                var index = parseInt(token, 10);
                if (!target) target = [];
                target[index] = tokens.length == 0 ? value : set(target[index], tokens.slice(0), value)
            } else if (token) {
                var index = token.replace(/^\s*|\s*$/g, "");
                if (!target) target = {};
                if (is(target, Array)) {
                    var temp = {};
                    for (var i = 0; i < target.length; ++i) {
                        temp[i] = target[i]
                    }
                    target = temp
                }
                target[index] = tokens.length == 0 ? value : set(target[index], tokens.slice(0), value)
            } else {
                return value
            }
            return target
        };
        var queryObject = function (a) {
            var self = this;
            self.keys = {};
            if (a.queryObject) {
                jQuery.each(a.get(), function (key, val) {
                    self.SET(key, val)
                })
            } else {
                jQuery.each(arguments, function () {
                    var q = "" + this;
                    q = q.replace(/^[?#]/, '');
                    q = q.replace(/[;&]$/, '');
                    if ($spaces) q = q.replace(/[+]/g, ' ');
                    jQuery.each(q.split(/[&;]/), function () {
                        var key = decodeURIComponent(this.split('=')[0] || "");
                        var val = decodeURIComponent(this.split('=')[1] || "");
                        if (!key) return;
                        if ($numbers) {
                            if (/^[+-]?[0-9]+\.[0-9]*$/.test(val)) val = parseFloat(val);
                            else if (/^[+-]?[0-9]+$/.test(val)) val = parseInt(val, 10)
                        }
                        val = (!val && val !== 0) ? true : val;
                        if (val !== false && val !== true && typeof val != 'number') val = val;
                        self.SET(key, val)
                    })
                })
            }
            return self
        };
        queryObject.prototype = {
            queryObject: true,
            has: function (key, type) {
                var value = this.get(key);
                return is(value, type)
            },
            GET: function (key) {
                if (!is(key)) return this.keys;
                var parsed = parse(key),
                    base = parsed[0],
                    tokens = parsed[1];
                var target = this.keys[base];
                while (target != null && tokens.length != 0) {
                    target = target[tokens.shift()]
                }
                return typeof target == 'number' ? target : target || ""
            },
            get: function (key) {
                var target = this.GET(key);
                if (is(target, Object)) return jQuery.extend(true, {}, target);
                else if (is(target, Array)) return target.slice(0);
                return target
            },
            SET: function (key, val) {
                var value = !is(val) ? null : val;
                var parsed = parse(key),
                    base = parsed[0],
                    tokens = parsed[1];
                var target = this.keys[base];
                this.keys[base] = set(target, tokens.slice(0), value);
                return this
            },
            set: function (key, val) {
                return this.copy().SET(key, val)
            },
            REMOVE: function (key) {
                return this.SET(key, null).COMPACT()
            },
            remove: function (key) {
                return this.copy().REMOVE(key)
            },
            EMPTY: function () {
                var self = this;
                jQuery.each(self.keys, function (key, value) {
                    delete self.keys[key]
                });
                return self
            },
            load: function (url) {
                var hash = url.replace(/^.*?[#](.+?)(?:\?.+)?$/, "$1");
                var search = url.replace(/^.*?[?](.+?)(?:#.+)?$/, "$1");
                return new queryObject(url.length == search.length ? '' : search, url.length == hash.length ? '' : hash)
            },
            empty: function () {
                return this.copy().EMPTY()
            },
            copy: function () {
                return new queryObject(this)
            },
            COMPACT: function () {
                function build(orig) {
                    var obj = typeof orig == "object" ? is(orig, Array) ? [] : {} : orig;
                    if (typeof orig == 'object') {
                        function add(o, key, value) {
                            if (is(o, Array)) o.push(value);
                            else o[key] = value
                        }
                        jQuery.each(orig, function (key, value) {
                            if (!is(value)) return true;
                            add(obj, key, build(value))
                        })
                    }
                    return obj
                }
                this.keys = build(this.keys);
                return this
            },
            compact: function () {
                return this.copy().COMPACT()
            },
            toString: function () {
                var i = 0,
                    queryString = [],
                    chunks = [],
                    self = this;
                var encode = function (str) {
                    str = str + "";
                    if ($spaces) str = str.replace(/ /g, "+");
                    return encodeURIComponent(str)
                };
                var addFields = function (arr, key, value) {
                    if (!is(value) || value === false) return;
                    var o = [encode(key)];
                    if (value !== true) {
                        o.push("=");
                        o.push(encode(value))
                    }
                    arr.push(o.join(""))
                };
                var build = function (obj, base) {
                    var newKey = function (key) {
                        return !base || base == "" ? [key].join("") : [base, "[", key, "]"].join("")
                    };
                    jQuery.each(obj, function (key, value) {
                        if (typeof value == 'object') build(value, newKey(key));
                        else addFields(chunks, newKey(key), value)
                    })
                };
                build(this.keys);
                if (chunks.length > 0) queryString.push($hash);
                queryString.push(chunks.join($separator));
                return queryString.join("")
            }
        };
        return new queryObject(location.search, location.hash)
    }
}(jQuery.query || {});
// the end


//jquery.lazy.min.js
/*! jQuery & Zepto Lazy v1.7.4 - http://jquery.eisbehr.de/lazy - MIT&GPL-2.0 license - Copyright 2012-2016 Daniel 'Eisbehr' Kern */
!function(t,e){"use strict";function r(r,a,i,l,u){function f(){L=t.devicePixelRatio>1,c(i),a.delay>=0&&setTimeout(function(){s(!0)},a.delay),(a.delay<0||a.combined)&&(l.e=v(a.throttle,function(t){"resize"===t.type&&(w=B=-1),s(t.all)}),l.a=function(t){c(t),i.push.apply(i,t)},l.g=function(){return i=n(i).filter(function(){return!n(this).data(a.loadedName)})},l.f=function(t){for(var e=0;e<t.length;e++){var r=i.filter(t[e]);r.length&&s(!1,r)}},s(),n(a.appendScroll).on("scroll."+u+" resize."+u,l.e))}function c(t){var i=a.defaultImage,o=a.placeholder,l=a.imageBase,u=a.srcsetAttribute,f=a.loaderAttribute,c=a._f||{};t=n(t).filter(function(){var t=n(this),r=m(this);return!t.data(a.handledName)&&(t.attr(a.attribute)||t.attr(u)||t.attr(f)||c[r]!==e)}).data("plugin_"+a.name,r);for(var s=0,d=t.length;s<d;s++){var A=n(t[s]),g=m(t[s]),h=A.attr(a.imageBaseAttribute)||l;g==N&&h&&A.attr(u)&&A.attr(u,b(A.attr(u),h)),c[g]===e||A.attr(f)||A.attr(f,c[g]),g==N&&i&&!A.attr(E)?A.attr(E,i):g==N||!o||A.css(O)&&"none"!=A.css(O)||A.css(O,"url('"+o+"')")}}function s(t,e){if(!i.length)return void(a.autoDestroy&&r.destroy());for(var o=e||i,l=!1,u=a.imageBase||"",f=a.srcsetAttribute,c=a.handledName,s=0;s<o.length;s++)if(t||e||A(o[s])){var g=n(o[s]),h=m(o[s]),b=g.attr(a.attribute),v=g.attr(a.imageBaseAttribute)||u,p=g.attr(a.loaderAttribute);g.data(c)||a.visibleOnly&&!g.is(":visible")||!((b||g.attr(f))&&(h==N&&(v+b!=g.attr(E)||g.attr(f)!=g.attr(F))||h!=N&&v+b!=g.css(O))||p)||(l=!0,g.data(c,!0),d(g,h,v,p))}l&&(i=n(i).filter(function(){return!n(this).data(c)}))}function d(t,e,r,i){++z;var o=function(){y("onError",t),p(),o=n.noop};y("beforeLoad",t);var l=a.attribute,u=a.srcsetAttribute,f=a.sizesAttribute,c=a.retinaAttribute,s=a.removeAttribute,d=a.loadedName,A=t.attr(c);if(i){var g=function(){s&&t.removeAttr(a.loaderAttribute),t.data(d,!0),y(T,t),setTimeout(p,1),g=n.noop};t.off(I).one(I,o).one(D,g),y(i,t,function(e){e?(t.off(D),g()):(t.off(I),o())})||t.trigger(I)}else{var h=n(new Image);h.one(I,o).one(D,function(){t.hide(),e==N?t.attr(C,h.attr(C)).attr(F,h.attr(F)).attr(E,h.attr(E)):t.css(O,"url('"+h.attr(E)+"')"),t[a.effect](a.effectTime),s&&(t.removeAttr(l+" "+u+" "+c+" "+a.imageBaseAttribute),f!==C&&t.removeAttr(f)),t.data(d,!0),y(T,t),h.remove(),p()});var m=(L&&A?A:t.attr(l))||"";h.attr(C,t.attr(f)).attr(F,t.attr(u)).attr(E,m?r+m:null),h.complete&&h.trigger(D)}}function A(t){var e=t.getBoundingClientRect(),r=a.scrollDirection,n=a.threshold,i=h()+n>e.top&&-n<e.bottom,o=g()+n>e.left&&-n<e.right;return"vertical"==r?i:"horizontal"==r?o:i&&o}function g(){return w>=0?w:w=n(t).width()}function h(){return B>=0?B:B=n(t).height()}function m(t){return t.tagName.toLowerCase()}function b(t,e){if(e){var r=t.split(",");t="";for(var a=0,n=r.length;a<n;a++)t+=e+r[a].trim()+(a!==n-1?",":"")}return t}function v(t,e){var n,i=0;return function(o,l){function u(){i=+new Date,e.call(r,o)}var f=+new Date-i;n&&clearTimeout(n),f>t||!a.enableThrottle||l?u():n=setTimeout(u,t-f)}}function p(){--z,i.length||z||y("onFinishedAll")}function y(t,e,n){return!!(t=a[t])&&(t.apply(r,[].slice.call(arguments,1)),!0)}var z=0,w=-1,B=-1,L=!1,T="afterLoad",D="load",I="error",N="img",E="src",F="srcset",C="sizes",O="background-image";"event"==a.bind||o?f():n(t).on(D+"."+u,f)}function a(a,o){var l=this,u=n.extend({},l.config,o),f={},c=u.name+"-"+ ++i;return l.config=function(t,r){return r===e?u[t]:(u[t]=r,l)},l.addItems=function(t){return f.a&&f.a("string"===n.type(t)?n(t):t),l},l.getItems=function(){return f.g?f.g():{}},l.update=function(t){return f.e&&f.e({},!t),l},l.force=function(t){return f.f&&f.f("string"===n.type(t)?n(t):t),l},l.loadAll=function(){return f.e&&f.e({all:!0},!0),l},l.destroy=function(){return n(u.appendScroll).off("."+c,f.e),n(t).off("."+c),f={},e},r(l,u,a,f,c),u.chainable?a:l}var n=t.jQuery||t.Zepto,i=0,o=!1;n.fn.Lazy=n.fn.lazy=function(t){return new a(this,t)},n.Lazy=n.lazy=function(t,r,i){if(n.isFunction(r)&&(i=r,r=[]),n.isFunction(i)){t=n.isArray(t)?t:[t],r=n.isArray(r)?r:[r];for(var o=a.prototype.config,l=o._f||(o._f={}),u=0,f=t.length;u<f;u++)(o[t[u]]===e||n.isFunction(o[t[u]]))&&(o[t[u]]=i);for(var c=0,s=r.length;c<s;c++)l[r[c]]=t[0]}},a.prototype.config={name:"lazy",chainable:!0,autoDestroy:!0,bind:"load",threshold:500,visibleOnly:!1,appendScroll:t,scrollDirection:"both",imageBase:null,defaultImage:"data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",placeholder:null,delay:-1,combined:!1,attribute:"data-src",srcsetAttribute:"data-srcset",sizesAttribute:"data-sizes",retinaAttribute:"data-retina",loaderAttribute:"data-loader",imageBaseAttribute:"data-imagebase",removeAttribute:!0,handledName:"handled",loadedName:"loaded",effect:"show",effectTime:0,enableThrottle:!0,throttle:250,beforeLoad:e,afterLoad:e,onError:e,onFinishedAll:e},n(t).on("load",function(){o=!0})}(window);
